import { GenericVerificationFlow } from "./GenericVerificationFlow"
import { useSecuritySectionStore } from "../stores/securitySectionStore"
import { showErrorNotification } from "@components/ui/Notification/Notification"
import {
	AEM_DICTIONARY_COLLECTIONS,
	useAEMDictionary
} from "@AEM/hooks/useAEMDictionary"
import { useOTPMutations } from "@hooks/useOTPMutations"
import { useSecurityMutations } from "../hooks/useSecurityMutations"
import { MFA_METHODS } from "@utils/constants.util"

export const MFAEmailSetup = () => {
	const { updateUser, goToIdle, setToken, token, user } =
		useSecuritySectionStore()
	const { sendEmailVerificationOTP, validateOTP, isLoading } = useOTPMutations()
	const { updateSecurity } = useSecurityMutations()
	const { dictionary } = useAEMDictionary(
		AEM_DICTIONARY_COLLECTIONS.REGISTRATION
	)

	const validateEmail = (value: string) => {
		if (!value) return dictionary?.emailRequiredMessage || ""
		if (!/^\S+@\S+\.\S+$/.test(value))
			return dictionary?.invalidEmailFormatMessage || ""
		return null
	}

	const handleSend = async (email: string) => {
		try {
			const otp = await sendEmailVerificationOTP.mutateAsync(email)
			setToken(otp?.data?.token ?? "")
			return otp?.data?.success ?? false
		} catch {
			return false
		}
	}

	const handleVerify = async (otp: string, input: string) => {
		try {
			const otpValidation = await validateOTP.mutateAsync({
				token: token ?? "",
				otp
			})
			if (otpValidation?.data?.success) {
				await handleSuccess(input, otpValidation?.data?.token ?? "")
				return true
			}
		} catch {}
		return false
	}

	const handleSuccess = async (email: string, token: string) => {
		const primaryMFA = MFA_METHODS.EMAIL
		try {
			await updateSecurity.mutateAsync({
				token: token ?? "",
				changedEmail: email,
				setEmailValidated: true,
				...(!user?.phoneVerified ? { primaryMFA } : {})
			})
			updateUser({
				email,
				emailVerified: true,
				...(!user?.phoneVerified ? { primaryMFA } : {})
			})
			goToIdle()
		} catch {
			showErrorNotification("Failed to update security settings")
		}
	}

	const handleResend = async (email: string) => {
		await sendEmailVerificationOTP.mutateAsync(email)
	}

	return (
		<GenericVerificationFlow
			title={dictionary?.verifyEmailToMFA || ""}
			description={dictionary?.updateEmailAdressForMFALabel || ""}
			inputLabel={dictionary?.enterYourNewEmailAddressLabel || ""}
			inputPlaceholder="amy@agency.xyz"
			inputType="email"
			validateInput={validateEmail}
			onSend={handleSend}
			onVerify={handleVerify}
			resendFunction={handleResend}
			isLoading={isLoading}
			goBack={goToIdle}
		/>
	)
}
